import script from "./Country.vue?vue&type=script&setup=true&lang=js"
export * from "./Country.vue?vue&type=script&setup=true&lang=js"

import "./Country.vue?vue&type=style&index=0&id=5e5ae8f6&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\kevin.chang\\Documents\\hzn\\oversea-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e5ae8f6"]])

export default __exports__